import { Grid2 } from "@mui/material"
import { DashboardHeader } from "components/Header/DashboardHeader"
import { JSX } from "react"
import { Outlet } from "react-router-dom"

export const BaseLayoutDashboard = (): JSX.Element => {
  return (
    <Grid2 container>
      <Grid2 size={12}>
        <DashboardHeader />
      </Grid2>
      <Grid2 size={12} sx={{ margin: "0.5em" }}>
        <Outlet />
      </Grid2>
    </Grid2>
  )
}
